import React from 'react';
import { shape, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import SingleCasePage from '../../templates/SingleCasePage';
import data from '../../data/cases/polarpumpen';
import nextCaseData from '../../data/casesThumb/inspospotr';
import InfoColumnSection from '../../components/InfoColumnSection';
import TitleAndBodySection from '../../components/case/TitleAndBodySection';
import DoubleImage from '../../components/case/DoubleImage';
import SingleImage from '../../components/case/SingleImage';
import variables from '../../styles/variables.module.scss';

const nextCase = {
  title: nextCaseData.title,
  path: nextCaseData.path,
  casebg: nextCaseData.casebg,
  color: nextCaseData.color,
  isWeb: nextCaseData.isWeb,
};

const PolarpumpenCasePage = ({ location }) => (
  <SingleCasePage
    location={location}
    caseName={data.key}
    data={data}
    nextCase={nextCase}
    quoteData={data.quoteData}
    alignHeroImage="right"
  >
    <Container>
      <Grid container direction="column">
        {
          data.titleBodyData[0] && (
            <TitleAndBodySection
              title={data.titleBodyData[0].title}
              body={data.titleBodyData[0].body}
              justify={data.titleBodyData[1] ? 'flex-end' : 'flex-start'}
            />
          )
        }
      </Grid>
    </Container>
    {
      data.environments && (
      <DoubleImage
        imageLeft={data.environments.env1}
        imageRight={data.environments.env2}
      />
      )
    }
    {
      data.titleBodyData[1] && (
        <TitleAndBodySection
          title={data.titleBodyData[1].title}
          body={data.titleBodyData[1].body}
        />
      )
    }
    {
      data.env1 && (
        <SingleImage
          image={data.env1}
          isAndroid={data.isAndroid}
          insideGrid
        />
      )
    }
    {
      data.infoTitle && data.infoBody && (
        <Grid item>
          <InfoColumnSection
            headlineSmall={data.title}
            backgroundColor={variables.carbonBlack}
            title={data.infoTitle}
            body={data.infoBody}
            isCase
          />
        </Grid>
      )
    }
    {
      data.env2 && (
        <SingleImage
          image={data.env2}
          isAndroid={data.isAndroid}
          insideGrid
        />
      )
    }
    {
      data.footerBanner && (
        <SingleImage
          image={data.footerBanner}
          isAndroid={data.isAndroid}
          insideGrid={data.footerBanner.insideGrid}
          style={{ width: '100%', margin: 0, backgroundColor: variables.athensGrey }}
        />
      )
    }
  </SingleCasePage>
);

PolarpumpenCasePage.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
};

export default PolarpumpenCasePage;
